/* eslint-disable react-refresh/only-export-components */
import {
  DimeButton,
  DimeSeparator,
  DimeSheet,
  DimeSheetContent,
  DimeSheetDescription,
  DimeSheetFooter,
  DimeSheetHeader,
  DimeSheetTitle,
  DimeSheetTrigger,
} from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createFileRoute('/design-system/sheet')({
  component: SheetDocs,
});

function DocsSection({ title, children }: Readonly<{ title: string; children: React.ReactNode }>) {
  return (
    <section className="mb-10">
      <h2 className="mb-1 text-xl font-semibold">{title}</h2>
      <DimeSeparator className="mb-4" />
      {children}
    </section>
  );
}

function SheetDocs() {
  return (
    <div>
      <h1 className="mb-1 text-3xl font-bold">Sheet</h1>
      <p className="mb-8 text-muted-foreground">
        Slide-over panel. Pair with <code className="font-mono text-sm">DimeSheetTrigger</code> and{' '}
        <code className="font-mono text-sm">DimeSheetContent</code>. Always include a{' '}
        <code className="font-mono text-sm">DimeSheetTitle</code>. Put actions in{' '}
        <code className="font-mono text-sm">DimeSheetFooter</code>.
      </p>

      <DocsSection title="Basic">
        <DimeSheet>
          <DimeSheetTrigger asChild>
            <DimeButton variant="outline">Open sheet</DimeButton>
          </DimeSheetTrigger>
          <DimeSheetContent>
            <DimeSheetHeader>
              <DimeSheetTitle>Navigation</DimeSheetTitle>
              <DimeSheetDescription>Mobile slide-over example.</DimeSheetDescription>
            </DimeSheetHeader>
            <DimeSheetFooter>
              <DimeButton variant="outline">Done</DimeButton>
            </DimeSheetFooter>
          </DimeSheetContent>
        </DimeSheet>
      </DocsSection>
    </div>
  );
}
